// ─── Payment copy ─────────────────────────────────────────────────────────────
// The PAYMENTS_ENABLED switch itself lives in ./features.js with every other
// feature switch; it is re-exported here so existing imports keep working.
export { PAYMENTS_ENABLED } from "./features";

export const PAYMENTS_OFF_MESSAGE =
  "Online payment is not available on YogaStay. Send a booking request and the school will share payment details with you directly.";

// Shown wherever a price appears while payments are off.
export const PAID_TO_SCHOOL = "paid directly to the school";
